import axios from "axios";
import { CreateInquiryRequest } from "./dto/CreateInquiry";

export const createInquiry = async (
  req: CreateInquiryRequest
): Promise<void> => {
  await axios.post<CreateInquiryRequest>("/api/inquiry", req, {
    headers: {
      "Content-Type": "application/json;charset=utf-8",
    },
  });
};
